const WorkingDom = () => (
    <div className="container mt-5">
        <div className="row justify-content-center">
            <div className="col-md-8 text-center">
                <div className="card shadow-lg border-0">
                    <div className="card-body p-5">
                        <div className="mb-4">
                            <i className="bi bi-tools" style={{ fontSize: '4rem', color: '#6c757d' }}></i>
                        </div>
                        <h2 className="card-title mb-3">페이지 준비 중</h2>
                        <p className="card-text text-muted mb-4">
                            이 페이지는 현재 작업 중입니다.<br />
                            빠른 시일 내에 완성하여 제공하겠습니다.
                        </p>
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
);

export default function PageWorking(props) {
    return (
        <>
            <WorkingDom />
        </>
    );
};